import { prefersReducedMotion } from '@theme/utilities';

/**
 * Smooth-scroll to location.hash after layout settles,
 * accounting for sticky header via CSS scroll-margin-top.
 */
async function scrollToHash() {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) return;

  let target;
  try {
    target = document.querySelector(hash);
  } catch {
    return;
  }
  if (!(target instanceof HTMLElement)) return;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Cancel the browser's instant hash jump so we can scroll smoothly.
  window.scrollTo(0, 0);

  await new Promise((resolve) => {
    if (document.readyState === 'complete') resolve();
    else window.addEventListener('load', resolve, { once: true });
  });

  if (document.fonts?.ready) {
    try {
      await document.fonts.ready;
    } catch {
      // Ignore font loading failures.
    }
  }

  // Wait two frames so header height CSS vars / images can settle.
  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

  const behavior = prefersReducedMotion() ? 'instant' : 'smooth';
  target.scrollIntoView({ behavior, block: 'start' });
}

scrollToHash();
